import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FREQUENCIES } from '../frequency-list';
import { LANGUAGES } from '../target-languages-list';
import { BLOODTYPES } from '../blood-type-list';
import { Frequency } from '../frequency';
import { TargetLanguage } from '../target-language';
import { BloodType } from '../blood-type';
import { Booking } from '../booking';
import { PersonalInfo } from '../personal-info';
import { HttpService } from '../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { PersonalInfoService } from '../personal-info.service';
import { MedicalInfoService } from '../medical-info.service';
import { SchoolInfoService } from '../school-info.service';
import { Vademecum } from '../vademecum';
import { ToastMessageService } from '../toast-message.service';
import { ApiError } from '../api-error';
import { LoginService } from '../security/login.service';
import { ApiErrorService } from '../api-error.service';

@Component({
  selector: 'app-test-server-down',
  templateUrl: './test-server-down.component.html',
  styleUrls: ['./test-server-down.component.css']
})
export class TestServerDownComponent implements OnInit {

  schoolForm!: FormGroup;
  medicalForm!: FormGroup;
  frequencies: Frequency[] = FREQUENCIES;
  targetLanguages: TargetLanguage[] = LANGUAGES;
  bloodTypes: BloodType[] = BLOODTYPES;
  uuid!: string;
  hasError: boolean = false;
  years: number[] = [];
  formsInvalid = false;
  booking!: Booking;
  sendingForm = false;
  submitFail = false;

  agreementForm!: FormGroup;

  locale: any;

  personalInfo!: PersonalInfo;
  lviLogo!: string;
  apiError: ApiError | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private route: ActivatedRoute,
    private router: Router,
    public personalInfoService: PersonalInfoService,
    public medicalInfoService: MedicalInfoService,
    public schoolInfoService: SchoolInfoService,
    public toastService: ToastMessageService,
    private loginService: LoginService,
    private apiErrorService: ApiErrorService
  ) {
    this.loginService.activatedNavigationComponent = false;
   }

  ngOnInit(): void {
    this.agreementForm = this.formBuilder.group({
      agreeWithTerms: [false, Validators.required],
      agreeToTakeStudentPicture: false
    });
    this.makeYears();
    this.uuid = "a7189da4-5faa-407a-82fd-8648891c5e21";
      this.httpService.getBookingByUuid(this.uuid)
      .subscribe(booking => {
        this.booking = booking;
      }, error => {
        if(error.status === 0){
          this.router.navigateByUrl("server-down");
          return;
        } else {
          this.apiErrorService.error = new ApiError(error);
          this.router.navigateByUrl("api-error");
        }

      });
  
  }

  makeYears(){
    let thisYear = moment().utc(true).year();
    let newYear = thisYear;
    this.years.push(thisYear);
    for(let i = 0; i < 20; i ++){
      newYear -= 1;
      this.years.push(newYear);
    }
  }

  sendVademecum() {
    this.formsInvalid = false;
    if(!this.medicalInfoService.medicalForm.valid || !this.schoolInfoService.schoolForm.valid || !this.personalInfoService.personalForm.valid){
      this.formsInvalid = true;
      this.submitFail = true;
      window.scroll(0, 0);
      return;
    }
    this.sendingForm = true;
    this.hasError = false;
    let vademecum = new Vademecum(
      this.medicalInfoService.medicalForm.value.streetName.trim(),
      this.medicalInfoService.medicalForm.value.streetNumber.trim(),
      this.medicalInfoService.medicalForm.value.city.trim(),
      this.medicalInfoService.medicalForm.value.postCode.trim(),
      moment(this.medicalInfoService.medicalForm.value.birthDate).utc(true),
      this.medicalInfoService.medicalForm.value.targetLanguage,
      this.medicalInfoService.medicalForm.value.doctorName.trim(),
      this.medicalInfoService.medicalForm.value.doctorPhoneNumber.trim(),
      this.medicalInfoService.medicalForm.value.experiencedDiseases.trim(),
      this.medicalInfoService.medicalForm.value.hasDiabetes,
      this.medicalInfoService.medicalForm.value.hasAsthma,
      this.medicalInfoService.medicalForm.value.hasHeartTrouble,
      this.medicalInfoService.medicalForm.value.hasEpilepsy,
      this.medicalInfoService.medicalForm.value.hasRheumatism,
      this.medicalInfoService.medicalForm.value.hasPhysicalDisability,
      this.medicalInfoService.medicalForm.value.hasSkinAffection,
      this.medicalInfoService.medicalForm.value.hasSleepDisorder,
      this.medicalInfoService.medicalForm.value.otherDiseases.trim(),
      moment(this.medicalInfoService.medicalForm.value.lastSkinTestDate).utc(true),
      this.medicalInfoService.medicalForm.value.skinTestPositive,
      this.medicalInfoService.medicalForm.value.hadTetanusVaccination,
      this.medicalInfoService.medicalForm.value.tetanusBoosterYear,
      this.medicalInfoService.medicalForm.value.hasAllergiesToMedicines,
      this.medicalInfoService.medicalForm.value.allergiesCauseMedicine.trim(),
      this.medicalInfoService.medicalForm.value.hasAllergiesToSubstances,
      this.medicalInfoService.medicalForm.value.allergiesCauseSubstance.trim(),
      this.medicalInfoService.medicalForm.value.isIncontinent,
      this.medicalInfoService.medicalForm.value.isQuicklyTired,
      this.medicalInfoService.medicalForm.value.isSensitiveToChilling,
      this.medicalInfoService.medicalForm.value.canSportWithoutRisk,
      this.medicalInfoService.medicalForm.value.needMedicalTreatment,
      this.medicalInfoService.medicalForm.value.medicinesQuantity.trim(),
      this.medicalInfoService.medicalForm.value.bloodType,
      this.medicalInfoService.medicalForm.value.otherInformations.trim(),
      this.medicalInfoService.medicalForm.value.emergencyContactAddress.trim(),
      this.medicalInfoService.medicalForm.value.hasMentalDisorder,
      this.medicalInfoService.medicalForm.value.mentalDisorderDescription.trim(),
      this.medicalInfoService.medicalForm.value.riskDescriptionToSport.trim(),

      this.schoolInfoService.schoolForm.value.studyDutchInSchool,
      this.schoolInfoService.schoolForm.value.studyEnglishInSchool,
      this.schoolInfoService.schoolForm.value.studyFrenchInSchool,
      this.schoolInfoService.schoolForm.value.dutchStudyYears,
      this.schoolInfoService.schoolForm.value.englishStudyYears,
      this.schoolInfoService.schoolForm.value.frenchStudyYears,
      this.schoolInfoService.schoolForm.value.dutchStudyHours,
      this.schoolInfoService.schoolForm.value.englishStudyHours,
      this.schoolInfoService.schoolForm.value.frenchStudyHours,
      this.schoolInfoService.schoolForm.value.frequencySpeakingWithFamily,
      this.schoolInfoService.schoolForm.value.frequencySpeakingWithFriends,
      this.schoolInfoService.schoolForm.value.hasLearningDifficulty,
      this.schoolInfoService.schoolForm.value.hadLanguageTest,
      moment(this.schoolInfoService.schoolForm.value.languageTestDate).utc(true),
      this.schoolInfoService.schoolForm.value.matterToReview.trim(),
      this.schoolInfoService.schoolForm.value.studyBookName.trim(),
      this.schoolInfoService.schoolForm.value.dutchTeacherName.trim(),
      this.schoolInfoService.schoolForm.value.englishTeacherName.trim(),
      this.schoolInfoService.schoolForm.value.frenchTeacherName.trim(),
      this.schoolInfoService.schoolForm.value.isComingWithFriends,
      this.schoolInfoService.schoolForm.value.friendName.trim(),
      this.booking,
      this.personalInfoService.personalForm.value.studentMobile.trim(),
      this.personalInfoService.personalForm.value.firstParentMobile.trim(),
      this.personalInfoService.personalForm.value.secondParentMobile.trim(),
      this.personalInfoService.personalForm.value.firstParentFirstName.trim(),
      this.personalInfoService.personalForm.value.firstParentLastName.trim(),
      this.personalInfoService.personalForm.value.secondParentFirstName.trim(),
      this.personalInfoService.personalForm.value.secondParentLastName.trim(),
      null,
      this.agreementForm.value.agreeWithTerms, 
      this.agreementForm.value.agreeToTakeStudentPicture);

    this.httpService.postVademecum(
      vademecum
    ).subscribe(() => {
      console.log("sent successfully");
      this.router.navigateByUrl("dashboard/" + this.uuid);
      window.scroll(0, 0);
      this.sendingForm = false;
    }, error => {
      if(error.status === 0){
        this.router.navigateByUrl("server-down");
        return;
      } else {
        this.apiErrorService.error = new ApiError(error);
        this.router.navigateByUrl("api-error");
      }
      this.hasError = true;
      this.sendingForm = false;
      this.formsInvalid = true;
      window.scroll(0, 0);
    });
  }

}
